var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"n-field"},[(_vm.show)?_c('Tooltip',{attrs:{"placement":_vm.placement,"content":_vm.content,"transfer":""}},[_c('div',{staticClass:"validation-indicator"},[_vm._t("default")],2)]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }